module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAaBAMAAACa4xtRAAAAElBMVEUAAAC7u7u7u7u7u7u7u7u7u7u4R+2wAAAABXRSTlMAW+rbTom6qycAAAAxSURBVAjXYxBSZIAA1VABGCMQwhANhQoxhlJDyAEmZABnwKVgiuHayRJAOB7hHbgHAaoNFR1JxF69AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/@dp/mbase-style/src/less/dp/img/arrow-ent.png
// module id = 362
// module chunks = 4